module.exports = __webpack_public_path__ + "img/btn_menu.a43b9ced.png";